import { awsApiInstance } from '../api/aws-api';
import { apiRetry } from '../api/api-helper';
import useAuth from '../hooks/auth-hooks';

import { ICardGroupTerminalResponse } from '../models/cardgroup.interface';
import { ICardGroupTerminalTax } from '../models/taxes.interface';
import { handleRouteError } from './route-helpers/route-error';

/**
 * Gets a list of card groups
 * 
 * @param {ICardGroupTerminalTax} group 
 * 
 * @returns {ICardGroupTerminalResponse} the api response
 */
const GetCardGroupTerminal = async ( group: ICardGroupTerminalTax ): Promise<ICardGroupTerminalResponse> => {
  try {
    apiRetry(awsApiInstance);

    const { userId } = useAuth()!; 

    const { data } = await awsApiInstance.get(`/card-group/${group.cardgroupId}/terminal`, {
      params: {
        'wpID': userId,
        'customerID': group.customerId,
        'cardGroupID': group.cardgroupId
      }
    });

    return data;
  } catch ( error ) {
    handleRouteError(error, 'Error getting card group data');
    throw(error);
  }
}

export default GetCardGroupTerminal;
